export const COMPLEMENT_PRODUCTS_CLICK_LINK = 'complementary styles';
export const ALTERNATIVE_PRODUCTS_CLICK_LINK = 'similar styles';

export const PDP_RELATED_PRODUCTS_ENTITY_TYPE = {
  alternativeStyles: 'ALTERNATIVE_STYLES',
  complementaryStyles: 'COMPLEMENTARY_STYLES'
};

export const ENTIRY_TYPE_TO_CLICK_LINK = {
  [PDP_RELATED_PRODUCTS_ENTITY_TYPE.alternativeStyles]:
    ALTERNATIVE_PRODUCTS_CLICK_LINK,
  [PDP_RELATED_PRODUCTS_ENTITY_TYPE.complementaryStyles]:
    COMPLEMENT_PRODUCTS_CLICK_LINK
};

export const RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE =
  'RELATED_PRODUCTS_TAB';
export const RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY = 'BUDGET_FRIENDLY_TAB';
export const RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES =
  'MORE_FITS_AND_SIZES_TAB';
export const RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND =
  'MORE_FROM_THIS_BRAND_TAB';

export const RELATED_PRODUCTS_TABS_LABELS = {
  [RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY]: 'Budget Friendly',
  [RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES]: 'Coordinating Styles',
  [RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND]: 'More From This Brand',
  [RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE]: 'You May Also Like'
};

export const RELATED_PRODUCTS_TABS = {
  [RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY]: {
    label:
      RELATED_PRODUCTS_TABS_LABELS[RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY],
    value: RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY
  },
  [RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES]: {
    label:
      RELATED_PRODUCTS_TABS_LABELS[
        RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES
      ],
    value: RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES
  },
  [RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND]: {
    label:
      RELATED_PRODUCTS_TABS_LABELS[
        RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND
      ],
    value: RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND
  },
  [RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE]: {
    label:
      RELATED_PRODUCTS_TABS_LABELS[RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE],
    value: RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE
  }
};
